// Tạo file: src/containers/Auth/Registration/PromoCodeWatcher.jsx

import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import Actions from 'actions';

const PromoCodeWatcher = ({selectedTier, setValidPromo, setErrorPromo, billingCycle}) => {
  const { values } = useFormikContext();
  const dispatch = useDispatch();

  const planId = selectedTier?.prices?.find(({ interval }) => interval === billingCycle)?.id

  useEffect(() => {
    const handler = debounce((code) => {
      if (!code) {
        setValidPromo(null);
        setErrorPromo(null);
        dispatch(Actions.clearPromo());
        return
      };
      dispatch(
        Actions.validatePromoCode(
          { code, price_id: planId },
          {
            success: (data) => {
              setValidPromo(data);
              setErrorPromo(null);
            },
            failure: (error) => {
              if (error?.response?.status === 404) {
                setErrorPromo('Invalid promo code');
              } else if(code) setErrorPromo(error?.response?.data?.error || error?.message);
            },
          }
        )
      );
    }, 500);

    handler(values.promoCode);

    return () => handler.cancel();
  }, [values.promoCode, dispatch, planId, setValidPromo, setErrorPromo]);

  return null;
};

export default PromoCodeWatcher;
